module.exports = __webpack_public_path__ + "static/media/DWN.e19c317d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/keyboard/DWN.png
// module id = 184
// module chunks = 0